import MenuNames from "../Menu/MenuNames.json";
import MenuActionsMappings from "../Menu/MenuActionsMappings.js";

const data = {
  routesWithParams: [
    "/feature-config/details",
    "/feature-config/list",
    "/courses/:id(\\d+)",
    "/countries/:id(\\d+)",
    "/states/:id(\\d+)",
    "/cities/:id(\\d+)",
    "/localities/:id(\\d+)",
    "/polygons/:id",
    "/relaxation-configuration/city-property/:id(\\d+)",
    "/city-property/change-logs/:id(\\d+)",
    "/city-property/keys/:id(\\d+)",
    "/delivery-drivers/:id/:detailType",
    "/orders/:id/:detailType?",
    "/disputes/:id/:detailType?",
    "/slots-details/:id(\\d+)",
    "/qc-details/:Feid",
    "/dlrc-details/:Feid",
    "/driver-app-releases",
    "/driver-app-releases/actions",
    "/chat-departments/:id(\\d+)",
    "/call-departments/:id(\\d+)",
    "/v2/fleet-coach/:id",
    "/order-payout/:filter_type/:filter_value",
    "/order-payout/:business_type/:filter_type/:filter_value",
    "/lifeline/:filter_type/:filter_value",
    "/driver-shelter/:id(\\d+)",
    "/notification_campaigns/:id",
    "/communication-hub/new/:tag",
    "/communication-hub/:tag/:id",
    "/communication-hub/history/:tag/:id",
    "/stories/:id",
    "/selfies",
    "/qc-details-v2/:feId",
    "/issue-types/:id/:action",
    "/sub-issue-types/:id/:action",
    "/sub-issue-types/:issueId",
    "/sub-issue-types/:id/tips",
    "/sub-issue-types/:id/tips/:tipId/:action",
    "/sub-issue-types/:id/tips/create",
  ],
  routesData: {
    /* PLOP_TEMPLATE_ROUTES_DATA */
    "/disputes": {
      title: "Disputes",
      path: "/disputes",
      text: "Disputes",
      menuName: MenuNames.DISPUTES,
      showInDashboard: true,
      dashboardButtonText: "Disputes",
      minAllowedAction: MenuActionsMappings[MenuNames.DISPUTES].DISPUTES_VIEW,
    },
    "/disputes/:id/:detailType?": {
      title: "Dispute",
      path: "/disputes/:id/:detailType?",
      text: "Dispute",
      menuName: MenuNames.DISPUTES,
      showInDashboard: false,
      dashboardButtonText: "Disputes",
      minAllowedAction: MenuActionsMappings[MenuNames.DISPUTES].DISPUTES_VIEW,
    },
    "/bulk-upload-bonuses": {
      title: "Bulk Upload Bonuses",
      path: "/bulk-upload-bonuses",
      text: "Bulk Upload Bonuses",
      menuName: MenuNames.BULK_UPLOAD_BONUSES,
      showInDashboard: true,
      dashboardButtonText: "Bulk Upload Bonuses",
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPLOAD_BONUSES].BULK_UPLOAD,
    },
    "/bulk-upload-ob-tags": {
      title: "Bulk Upload OB Tags",
      path: "/bulk-upload-ob-tags",
      text: "Bulk Upload OB Tags",
      menuName: MenuNames.BULK_UPLOAD_OB_TAGS,
      showInDashboard: true,
      dashboardButtonText: "Bulk Upload OB Tags",
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPLOAD_OB_TAGS].BULK_UPLOAD,
    },
    "/restricted-payout-drivers": {
      title: "Restricted Payout Drivers",
      path: "/restricted-payout-drivers",
      text: "Restricted Payout Drivers",
      menuName: MenuNames.RESTRICTED_PAYOUT_DRIVERS,
      showInDashboard: true,
      dashboardButtonText: "Restricted Payout Drivers",
      minAllowedAction:
        MenuActionsMappings[MenuNames.RESTRICTED_PAYOUT_DRIVERS].VIEW,
    },
    "/driver-tds-certificates": {
      title: "Driver Tds Certificates",
      path: "/driver-tds-certificates",
      text: "Driver Tds Certificates",
      menuName: MenuNames.DRIVER_TDS_CERTIFICATES,
      showInDashboard: true,
      dashboardButtonText: "Driver Tds Certificates",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_TDS_CERTIFICATES].VIEW,
    },
    "/bulk-upload-ev-inventory": {
      title: "Bulk Upload Ev Inventory",
      path: "/bulk-upload-ev-inventory",
      text: "Bulk Upload Ev Inventory",
      menuName: MenuNames.EV_INVENTORY,
      showInDashboard: true,
      dashboardButtonText: "Bulk Upload Ev Inventory",
      minAllowedAction: MenuActionsMappings[MenuNames.EV_INVENTORY].BULK_UPLOAD,
    },
    "/Poi": {
      title: "Bulk Poi Onboarding",
      path: "/Poi",
      text: "Bulk Poi Onboarding",
      menuName: MenuNames.WALKER,
      showInDashboard: true,
      minAllowedAction: MenuActionsMappings[MenuNames.WALKER].BULK_POI_UPLOAD,
    },
    "/bulk-modify-shelter": {
      title: "Bulk Modify Shelters",
      path: "/bulk-modify-shelter",
      text: "Bulk Modify Shelters",
      menuName: MenuNames.DRIVER_SHELTER,
      showInDashboard: true,
      dashboardButtonText: "Bulk Modify Shelter",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_SHELTER].BULK_UPLOAD,
    },
    "/driver-shelter": {
      title: "Driver Shelters",
      path: "/driver-shelter",
      text: "Driver Shelters",
      menuName: MenuNames.DRIVER_SHELTER,
      showInDashboard: true,
      dashboardButtonText: "Driver Shelters",
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_SHELTER].READ,
    },
    "/driver-shelter/:id(\\d+)": {
      title: "Driver Shelters",
      path: "/driver-shelter/:id(\\d+)",
      text: "Driver Shelters",
      menuName: MenuNames.DRIVER_SHELTER,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_SHELTER].UPDATE,
    },
    "/notification_campaigns": {
      title: "Notifications",
      path: "/notification_campaigns",
      text: "Notifications",
      menuName: MenuNames.DRIVER_NOTIFICATION,
      showInDashboard: true,
      dashboardButtonText: "Notifications",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_NOTIFICATION].CAMPAIGN_VIEW,
    },
    "/notification_campaigns/:id": {
      title: "Campaign Detail",
      path: "/notification_campaigns/:id",
      text: "Campaign Detail on ID",
      menuName: MenuNames.DRIVER_NOTIFICATION,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_NOTIFICATION].CAMPAIGN_VIEW,
      redirectPath: "/notification_campaigns",
    },
    "/notification_campaign/create_campaign": {
      title: "Create Campaign",
      path: "/notification_campaign/create_campaign",
      text: "Create Campaign",
      menuName: MenuNames.DRIVER_NOTIFICATION,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_NOTIFICATION].CAMPAIGN_CREATE,
      redirectPath: "/notification_campaigns",
    },
    "/stories": {
      title: "Stories",
      path: "/stories",
      text: "Stories",
      menuName: MenuNames.DRIVER_STORIES,
      showInDashboard: true,
      dashboardButtonText: "Stories",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_STORIES].STORIES_VIEW,
    },
    "/stories/create_campaign": {
      title: "Create Story",
      path: "/stories/create_campaign",
      text: "Create Story",
      menuName: MenuNames.DRIVER_STORIES,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_STORIES].STORIES_CREATE,
      redirectPath: "/stories",
    },
    "/stories/:id": {
      title: "Story Detail",
      path: "/stories/:id",
      text: "Story Detail on ID",
      menuName: MenuNames.DRIVER_STORIES,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_STORIES].STORIES_VIEW,
      redirectPath: "/stories",
    },
    "/stories/create_external_entity": {
      title: "Create External Entity",
      path: "/stories/create_external_entity",
      text: "Create External Entity",
      menuName: MenuNames.DRIVER_STORIES,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_STORIES].STORIES_CREATE,
      redirectPath: "/stories",
    },
    "/stories/view_external_entities": {
      title: "View External Entity",
      path: "/stories/view_external_entities",
      text: "View External Entity",
      menuName: MenuNames.DRIVER_STORIES,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_STORIES].STORIES_VIEW,
      redirectPath: "/stories",
    },
    "/communication-hub": {
      title: "Hub",
      path: "/communication-hub",
      text: "Communication Hub",
      menuName: MenuNames.COMMUNICATION_HUB,
      dashboardButtonText: "Hub",
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.COMMUNICATION_HUB].COMMUNICATION_HUB_VIEW,
    },
    "/communication-hub/new/:tag": {
      title: "Hub",
      path: "/communication-hub/new/:tag",
      text: "Communication Hub",
      menuName: MenuNames.COMMUNICATION_HUB,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.COMMUNICATION_HUB]
          .COMMUNICATION_HUB_CREATE,
      redirectPath: "/communication-hub",
    },
    "/communication-hub/:tag/:id": {
      title: "Hub",
      path: "/communication-hub/:tag/:id",
      text: "Communication Hub",
      menuName: MenuNames.COMMUNICATION_HUB,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.COMMUNICATION_HUB].COMMUNICATION_HUB_VIEW,
      redirectPath: "/communication-hub",
    },
    "/communication-hub/history/:tag/:id": {
      title: "Hub",
      path: "/communication-hub/history/:tag/:id",
      text: "Communication Hub",
      menuName: MenuNames.COMMUNICATION_HUB,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.COMMUNICATION_HUB].COMMUNICATION_HUB_VIEW,
      redirectPath: "/communication-hub",
    },
    "/banner": {
      title: "Banner",
      path: "/banner",
      text: "Banner",
      menuName: MenuNames.DRIVER_BANNER,
      dashboardButtonText: "Banner",
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_BANNER].BANNER_VIEW,
    },
    "/banner/details": {
      title: "Banner Details",
      path: "/banner/details",
      text: "Banner Details",
      menuName: MenuNames.DRIVER_BANNER,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_BANNER].BANNER_VIEW,
      redirectPath: "/banner",
    },
    "/banner/target_audience": {
      title: "Banner Target Audience",
      path: "/banner/target_audience",
      text: "Banner Target Audience",
      menuName: MenuNames.DRIVER_BANNER,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_BANNER].BANNER_VIEW,
      redirectPath: "/banner",
    },
    "/banner/create": {
      title: "Create Banner",
      path: "/banner/create",
      text: "Create Banner",
      menuName: MenuNames.DRIVER_BANNER,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_BANNER].BANNER_CREATE,
      redirectPath: "/banner",
    },
    "/Walker": {
      title: "Bulk Walker Onboarding",
      path: "/Walker",
      text: "Bulk Walker Onboarding",
      menuName: MenuNames.WALKER,
      showInDashboard: true,
      dashboardButtonText: "Walker",
      minAllowedAction: MenuActionsMappings[MenuNames.WALKER].BULK_UPLOAD,
    },
    "/walker-details": {
      title: "Walker Details",
      path: "/walker-details",
      text: "Walker Details",
      menuName: MenuNames.WALKER,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.WALKER].WALKER_DETAILS_VIEW,
    },
    "/bulk-inventory-upload": {
      title: "Bulk Inventory Upload",
      path: "/bulk-inventory-upload",
      text: "Bulk Inventory Upload",
      menuName: MenuNames.SPIN_THE_WHEEL,
      showInDashboard: true,
      dashboardButtonText: "Spin The Wheel",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SPIN_THE_WHEEL].BULK_INVENTORY_UPLOAD,
    },
    "/bulk-coupon-upload": {
      title: "Bulk Coupon Upload",
      path: "/bulk-coupon-upload",
      text: "Bulk Coupon Upload",
      menuName: MenuNames.SPIN_THE_WHEEL,
      showInDashboard: true,
      dashboardButtonText: "Spin The Wheel",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SPIN_THE_WHEEL].BULK_COUPON_UPLOAD,
    },
    "/inventories": {
      title: "Inventories",
      path: "/inventories",
      text: "Inventories",
      menuName: MenuNames.SPIN_THE_WHEEL,
      showInDashboard: true,
      dashboardButtonText: "Inventories",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SPIN_THE_WHEEL].INVENTORIES_LIST,
    },
    "/ofs-cache-dashboard": {
      title: "OFS Cache Dashboard",
      path: "/ofs-cache-dashboard",
      text: "OFS Cache Dashboard",
      menuName: MenuNames.OFS_CACHE_DASHBOARD,
      showInDashboard: true,
      dashboardButtonText: "OFS Cache Dashboard",
      minAllowedAction:
        MenuActionsMappings[MenuNames.OFS_CACHE_DASHBOARD].OFS_CACHE_VIEW,
    },

    "/order-payout": {
      title: "Order Payouts",
      path: "/order-payout",
      text: "Order Payouts",
      menuName: MenuNames.ORDER_PAYOUT,
      showInDashboard: true,
      dashboardButtonText: "Order Payout",
      minAllowedAction:
        MenuActionsMappings[MenuNames.ORDER_PAYOUT].ORDER_PAYOUT,
    },
    "/lifeline": {
      title: "Lifeline",
      path: "/lifeline",
      text: "Lifeline",
      menuName: MenuNames.LIFELINE,
      showInDashboard: true,
      dashboardButtonText: "Lifeline",
      minAllowedAction: MenuActionsMappings[MenuNames.LIFELINE].LIFELINE,
    },
    "/orders": {
      title: "Orders",
      path: "/orders",
      text: "Orders",
      menuName: MenuNames.ORDERS,
      showInDashboard: true,
      dashboardButtonText: "Orders",
      minAllowedAction: MenuActionsMappings[MenuNames.ORDERS].ORDERS_VIEW,
    },
    "/orders/:id/:detailType?": {
      title: "Order",
      path: "/orders/:id/:detailType?",
      text: "Order",
      menuName: MenuNames.ORDERS,
      showInDashboard: false,
      dashboardButtonText: "Orders",
      minAllowedAction: MenuActionsMappings[MenuNames.ORDERS].ORDERS_VIEW,
    },
    "/lifeline/:filter_type/:filter_value": {
      title: "Lifeline",
      path: "/lifeline/:filter_type/:filter_value",
      text: "Lifeline",
      menuName: MenuNames.LIFELINE,
      showInDashboard: false,
      dashboardButtonText: "Lifeline",
      minAllowedAction: MenuActionsMappings[MenuNames.LIFELINE].LIFELINE,
    },
    "/order-payout/:filter_type/:filter_value": {
      title: "Order Payouts",
      path: "/order-payout/:filter_type/:filter_value",
      text: "Order Payouts",
      menuName: MenuNames.ORDER_PAYOUT,
      showInDashboard: false,
      dashboardButtonText: "Order Payout",
      minAllowedAction:
        MenuActionsMappings[MenuNames.ORDER_PAYOUT].ORDER_PAYOUT,
    },
    "/order-payout/:business_type/:filter_type/:filter_value": {
      title: "Order Payouts",
      path: "/order-payout/:business_type/:filter_type/:filter_value",
      text: "Order Payouts",
      menuName: MenuNames.ORDER_PAYOUT,
      showInDashboard: false,
      dashboardButtonText: "Order Payout",
      minAllowedAction:
        MenuActionsMappings[MenuNames.ORDER_PAYOUT].ORDER_PAYOUT,
    },
    "/bulk-upload-carrier-change-manager": {
      title: "Bulk Upload Carrier Change Manager",
      path: "/bulk-upload-carrier-change-manager",
      text: "Bulk Upload Carrier Change Manager",
      menuName: MenuNames.BULK_UPLOAD_CARRIER_CHANGE_MANAGER,
      showInDashboard: true,
      dashboardButtonText: "Bulk Upload Carrier Change Manager",
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPLOAD_CARRIER_CHANGE_MANAGER]
          .BULK_UPLOAD,
    },
    "/v2/fleet-coach-bulk-upload": {
      title: "Bulk Upload Driver FC Mapping",
      path: "/v2/fleet-coach-bulk-upload",
      text: "Bulk Upload Driver FC Mapping",
      menuName: MenuNames.FLEET_COACH_V2,
      showInDashboard: true,
      dashboardButtonText: "Bulk Upload Driver FC Mapping",
      minAllowedAction:
        MenuActionsMappings[MenuNames.FLEET_COACH_V2].BULK_UPLOAD,
    },
    "/v2/fleet-coach": {
      title: "Fleet Coach",
      path: "/v2/fleet-coach",
      text: "Fleet Coach",
      menuName: MenuNames.FLEET_COACH_V2,
      showInDashboard: true,
      dashboardButtonText: "Fleet Coach",
      minAllowedAction: MenuActionsMappings[MenuNames.FLEET_COACH_V2].LIST,
    },
    "/v2/fleet-coach-task": {
      title: "Fleet Coach Task",
      path: "/v2/fleet-coach-task",
      text: "Fleet Coach Task",
      menuName: MenuNames.FLEET_COACH_TASK_V2,
      showInDashboard: true,
      dashboardButtonText: "Fleet Coach Task",
      minAllowedAction:
        MenuActionsMappings[MenuNames.FLEET_COACH_TASK_V2]
          .FLEET_COACH_TASK_VIEW,
    },
    "/v2/fleet-coach/:id": {
      title: "Fleet Coach",
      path: "/v2/fleet-coach/:id",
      text: "Fleet Coach on ID",
      menuName: MenuNames.FLEET_COACH_V2,
      showInDashboard: false,
      dashboardButtonText: "Fleet Coach",
      minAllowedAction: MenuActionsMappings[MenuNames.FLEET_COACH_V2].LIST,
    },
    "/pending-deduction-bulk-upload": {
      title: "Pending Deduction Bulk Upload",
      path: "/pending-deduction-bulk-upload",
      text: "Pending Deduction Bulk Upload",
      menuName: MenuNames.PENDING_DEDUCTION,
      showInDashboard: true,
      dashboardButtonText: "Pending Deduction Bulk Upload",
      minAllowedAction:
        MenuActionsMappings[MenuNames.PENDING_DEDUCTION].BULK_UPLOAD,
    },
    "/pending-deduction": {
      title: "Pending Deduction",
      path: "/pending-deduction",
      text: "Pending Deduction",
      menuName: MenuNames.PENDING_DEDUCTION,
      showInDashboard: true,
      dashboardButtonText: "Pending Deduction",
      minAllowedAction: MenuActionsMappings[MenuNames.PENDING_DEDUCTION].LIST,
    },
    "/chat-departments": {
      title: "Chat Departments",
      path: "/chat-departments",
      text: "Chat Departments",
      menuName: MenuNames.LOGISTICS_CHAT_DEPARTMENTS,
      showInDashboard: true,
      dashboardButtonText: "Chat Departments",
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_CHAT_DEPARTMENTS].READ,
    },
    "/chat-departments/:id(\\d+)": {
      title: "Chat Departments",
      path: "/chat-departments/:id(\\d+)",
      text: "Chat Departments on ID",
      menuName: MenuNames.LOGISTICS_CHAT_DEPARTMENTS,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_CHAT_DEPARTMENTS].READ,
    },
    "/driver-app-releases/actions": {
      title: "Driver App Releases",
      path: "/driver-app-releases/actions",
      text: "Driver App Releases Actions",
      menuName: MenuNames.DRIVER_APP_RELEASE,
      showInDashboard: false,
      dashboardButtonText: "Driver App Releases",
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_APP_RELEASE].READ,
    },
    "/driver-app-releases": {
      title: "Driver App Releases",
      path: "/driver-app-releases",
      text: "Driver App Releases",
      menuName: MenuNames.DRIVER_APP_RELEASE,
      showInDashboard: true,
      dashboardButtonText: "Driver App Releases",
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_APP_RELEASE].READ,
    },
    "/gigs-support": {
      title: "Gigs Support",
      path: "/gigs-support",
      text: "Gigs Support",
      menuName: MenuNames.GIGS_SUPPORT,
      showInDashboard: true,
      dashboardButtonText: "Gigs Support",
      minAllowedAction: MenuActionsMappings[MenuNames.GIGS_SUPPORT].LIST,
    },
    "/gigs-capacity-change": {
      title: "Capacity Change",
      path: "/gigs-capacity-change",
      text: "Capacity Change",
      menuName: MenuNames.MANUAL_SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Capacity Change",
      minAllowedAction:
        MenuActionsMappings[MenuNames.MANUAL_SLOT_CAPACITY_UPDATE].LIST,
    },
    "/qc-details": {
      title: "Qc Details",
      path: "/qc-details",
      text: "Qc Details",
      menuName: MenuNames.QUALITY_CHECK,
      showInDashboard: true,
      dashboardButtonText: "Qc Details",
      minAllowedAction: MenuActionsMappings[MenuNames.QUALITY_CHECK].READ,
    },
    "/qc-details-v2": {
      title: "Qc Details V2",
      path: "/qc-details-v2",
      text: "Qc Details V2",
      menuName: MenuNames.QUALITY_CHECK_V2,
      showInDashboard: true,
      dashboardButtonText: "Qc Details V2",
      minAllowedAction: MenuActionsMappings[MenuNames.QUALITY_CHECK_V2].READ,
    },
    "/qc-details-v2/:feId": {
      title: "Qc Details V2",
      path: "/qc-details-v2/:feId",
      text: "Qc Details V2",
      menuName: MenuNames.QUALITY_CHECK_V2,
      showInDashboard: false,
      dashboardButtonText: "Qc Details V2",
      minAllowedAction: MenuActionsMappings[MenuNames.QUALITY_CHECK_V2].READ,
    },
    "/onboarding-details": {
      title: "Onboarding Details",
      path: "/onboarding-details",
      text: "Onboarding Details",
      menuName: MenuNames.DRIVER_ONBOARDING,
      showInDashboard: true,
      dashboardButtonText: "Onboarding Details",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_ONBOARDING]
          .DRIVER_ONBOARDING_APPLICATION_DETAILS,
    },
    "/qc-details/:Feid": {
      title: "Qc Details",
      path: "/qc-details/:Feid",
      text: "Qc Details",
      menuName: MenuNames.QUALITY_CHECK,
      showInDashboard: true,
      dashboardButtonText: "Qc Details",
      minAllowedAction: MenuActionsMappings[MenuNames.QUALITY_CHECK].READ,
    },
    "/dlrc-details": {
      title: "DL RC Details",
      path: "/dlrc-details",
      text: "DL RC Details",
      menuName: MenuNames.DLRC_CHECK,
      showInDashboard: true,
      dashboardButtonText: "DL RC Details",
      minAllowedAction: MenuActionsMappings[MenuNames.DLRC_CHECK].READ,
    },
    "/dlrc-details/:Feid": {
      title: "DL RC Details",
      path: "/dlrc-details/:Feid",
      text: "DL RC Details",
      menuName: MenuNames.DLRC_CHECK,
      showInDashboard: true,
      dashboardButtonText: "DL RC Details",
      minAllowedAction: MenuActionsMappings[MenuNames.DLRC_CHECK].READ,
    },
    "/merchant-facade": {
      title: "Merchant Facade",
      path: "/merchant-facade",
      text: "Merchant Facade",
      menuName: MenuNames.MERCHANT_FACADE_PIC,
      showInDashboard: true,
      dashboardButtonText: "Merchant Facade",
      minAllowedAction: MenuActionsMappings[MenuNames.MERCHANT_FACADE_PIC].READ,
    },
    "/slot-capacity-update": {
      title: "Slot Capacity Update",
      path: "/slot-capacity-update",
      text: "Slot Capacity Update",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Bulk Update Slot Capacity",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/slot-capacity-attendance-exemption": {
      title: "Gigs exemption upload (Slot)",
      path: "/slot-capacity-attendance-exemption",
      text: "Gigs exemption upload (Slot)",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Bulk Update Slot Capacity",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/driver-slots-attendance-exemption": {
      title: "Gigs exemption upload (Driver)",
      path: "/driver-slots-attendance-exemption",
      text: "Gigs exemption upload (Driver)",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Bulk Update Driver Slot Exemption",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/driver-star-gigs-exemption": {
      title: "Star Gigs exemption upload (Driver)",
      path: "/driver-star-gigs-exemption",
      text: "Star Gigs exemption upload (Driver)",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Bulk Update Driver Star Gigs Exemption",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/bulk-gigs-opt-out": {
      title: "Gigs Opt Out (Driver)",
      path: "/bulk-gigs-opt-out",
      text: "Gigs Opt Out (Drivers)",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Gigs Opt Out (Drivers)",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/bulk-gigs-opt-in": {
      title: "Gigs Opt In (Driver)",
      path: "/bulk-gigs-opt-in",
      text: "Gigs Opt In (Drivers)",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Gigs Opt In (Drivers)",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/gigs-cancellation-fee-exemption": {
      title: "Gigs Cancellation Fee Exemption (Slot)",
      path: "/gigs-cancellation-fee-exemption",
      text: "Gigs Cancellation Fee Exemption (Slot)",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Gigs Cancellation Fee Exemption",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/driver-gigs-cancellation-fee-exemption": {
      title: "Gigs Cancellation Fee Exemption (Driver)",
      path: "/driver-gigs-cancellation-fee-exemption",
      text: "Gigs Cancellation Fee Exemption (Driver)",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      dashboardButtonText: "Driver Gigs Cancellation Fee Exemption",
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/slots-details": {
      title: "Slots Details",
      path: "/slots-details",
      text: "Slots Details",
      menuName: MenuNames.DRIVER_SLOT_VIEW_DETAILS,
      showInDashboard: true,
      dashboardButtonText: "Slots Details",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_SLOT_VIEW_DETAILS]
          .SLOT_VIEW_DETAILS,
    },
    "/slots-details/:id(\\d+)": {
      title: "Slots Details",
      path: "/slots-details/:id(\\d+)",
      text: "Slot Details on ID",
      menuName: MenuNames.DRIVER_SLOT_VIEW_DETAILS,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_SLOT_VIEW_DETAILS]
          .SLOT_VIEW_DETAILS,
    },
    "/boundaries": {
      title: "Boundaries",
      path: "/boundaries",
      text: "Boundaries",
      menuName: MenuNames.GEO_BOUNDARIES_DISPLAY,
      showInDashboard: true,
      dashboardButtonText: "Boundaries",
      minAllowedAction:
        MenuActionsMappings[MenuNames.GEO_BOUNDARIES_DISPLAY]
          .LOCALITY_BOUNDARIES,
    },
    "/rider-payouts": {
      title: "Rider Payouts",
      path: "/rider-payouts",
      text: "Rider Payouts",
      menuName: MenuNames.RIDER_PAYOUT_HISTORY,
      showInDashboard: true,
      dashboardButtonText: "Rider Payouts",
      minAllowedAction:
        MenuActionsMappings[MenuNames.RIDER_PAYOUT_HISTORY].LIST,
    },
    "/rider-offers": {
      title: "Rider Offers",
      path: "/rider-offers",
      text: "Rider Offers",
      menuName: MenuNames.RIDER_PAYOUT_HISTORY,
      showInDashboard: true,
      dashboardButtonText: "Rider Offers",
      minAllowedAction:
        MenuActionsMappings[MenuNames.RIDER_PAYOUT_HISTORY].LIST,
    },
    "/platform-fee-details": {
      title: "Onboarding Fee",
      path: "/platform-fee-details",
      text: "Onboarding Fee",
      menuName: MenuNames.RIDER_PAYOUT_HISTORY,
      showInDashboard: true,
      dashboardButtonText: "Onboarding Fees",
      minAllowedAction:
        MenuActionsMappings[MenuNames.RIDER_PAYOUT_HISTORY].LIST,
    },
    "/selfies": {
      title: "Grooming Selfies",
      path: "/selfies",
      text: "Grooming Selfies",
      menuName: MenuNames.DRIVER_SELFIES,
      showInDashboard: true,
      dashboardButtonText: "Grooming Selfies",
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_SELFIES].LIST,
    },
    "/driver-asset-issuance-tracking": {
      title: "Driver Asset Issuance Tracking",
      path: "/driver-asset-issuance-tracking",
      text: "Driver Asset Issuance Tracking",
      menuName: MenuNames.DRIVER_ASSET_ISSUANCE_TRACKING,
      showInDashboard: true,
      dashboardButtonText: "Driver Asset Issuance Tracking",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_ASSET_ISSUANCE_TRACKING].LIST,
    },
    "/": {
      title: "Home",
      path: "/",
      text: "Zomato Logistics Admin Dashboard",
      showInDashboard: false,
    },
    "/courses/:id(\\d+)": {
      title: "Course Detail",
      path: "/courses/:id",
      text: "Course Detail On ID",
      menuName: MenuNames.TRAINING,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.TRAINING].COURSE_INFO,
    },
    "/feature": {
      title: "Features",
      path: "/feature",
      text: "View Features",
      menuName: MenuNames.FEATURE,
      showInDashboard: true,
      dashboardButtonText: "Features",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE].LIST,
    },
    "/feature-toggle": {
      title: "Feature Toggle",
      path: "/feature-toggle",
      text: "Feature Toggle",
      menuName: MenuNames.FEATURE_TOGGLE,
      showInDashboard: true,
      dashboardButtonText: "Feature Toggle",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_TOGGLE].LIST,
    },
    "/feature-toggle-delete-by-ids": {
      title: "Feature Toggle Bulk Delete",
      path: "/feature-toggle-delete-by-ids",
      text: "Feature Toggle Bulk Delete",
      menuName: MenuNames.FEATURE_TOGGLE,
      showInDashboard: true,
      dashboardButtonText: "Feature Toggle Bulk Upload",
      minAllowedAction:
        MenuActionsMappings[MenuNames.FEATURE_TOGGLE].BULK_DELETE,
    },
    "/states": {
      title: "States",
      path: "/states",
      text: "States",
      menuName: MenuNames.STATE,
      showInDashboard: true,
      dashboardButtonText: "States",
      minAllowedAction: MenuActionsMappings[MenuNames.STATE].LIST,
    },
    "/states/:id(\\d+)": {
      title: "States",
      path: "/states/:id(\\d+)",
      text: "States On ID",
      menuName: MenuNames.STATE,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.STATE].DETAIL,
      redirectPath: "/states",
    },
    "/countries": {
      title: "Countries",
      path: "/countries",
      text: "Countries",
      menuName: MenuNames.COUNTRY,
      showInDashboard: true,
      dashboardButtonText: "Countries",
      minAllowedAction: MenuActionsMappings[MenuNames.COUNTRY].LIST,
    },
    "/countries/:id(\\d+)": {
      title: "Countries",
      path: "/countries/:id(\\d+)",
      text: "Countries On ID",
      menuName: MenuNames.COUNTRY,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.COUNTRY].DETAIL,
      redirectPath: "/countries",
    },
    "/cities": {
      title: "Cities",
      path: "/cities",
      text: "Cities",
      menuName: MenuNames.CITY,
      showInDashboard: true,
      dashboardButtonText: "Cities",
      minAllowedAction: MenuActionsMappings[MenuNames.CITY].LIST,
    },
    "/cities/:id(\\d+)": {
      title: "Cities",
      path: "/cities/:id(\\d+)",
      text: "Cities On ID",
      menuName: MenuNames.CITY,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.CITY].DETAIL,
      redirectPath: "/cities",
    },
    "/localities": {
      title: "Localities",
      path: "/localities",
      text: "Localities",
      menuName: MenuNames.LOCALITY,
      showInDashboard: true,
      dashboardButtonText: "Localities",
      minAllowedAction: MenuActionsMappings[MenuNames.LOCALITY].LIST,
    },
    "/localities/:id(\\d+)": {
      title: "Localities",
      path: "/localities/:id(\\d+)",
      text: "Localities On ID",
      menuName: MenuNames.LOCALITY,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.LOCALITY].DETAIL,
      redirectPath: "/localities",
    },
    "/polygons": {
      title: "Polygons", // polygons/id bhi krna h
      path: "/polygons",
      text: "Polygons",
      menuName: MenuNames.POLYGON,
      showInDashboard: true,
      dashboardButtonText: "Polygons",
      minAllowedAction: MenuActionsMappings[MenuNames.POLYGON].LIST,
    },
    "/polygons/:id": {
      title: "Polygons",
      path: "/polygons/:id",
      text: "Polygons On ID",
      menuName: MenuNames.POLYGON,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.POLYGON].DETAIL,
      redirectPath: "/polygons",
    },
    "/polygons-types": {
      title: "Polygon Types",
      path: "/polygons-types",
      text: "Polygon Types",
      menuName: MenuNames.POLYGON,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.POLYGON].TYPES,
    },
    "/driver-tags": {
      title: "Driver Tags",
      path: "/driver-tags",
      text: "Driver Tags",
      menuName: MenuNames.DRIVER_TAG,
      showInDashboard: true,
      dashboardButtonText: "Driver Tags",
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_TAG].LIST,
    },
    "/relaxation-configuration/gen-setting": {
      title: "Relaxation Configuration",
      path: "/relaxation-configuration/gen-setting",
      text: "Relaxation Configuration",
      menuName: MenuNames.CONFIG,
      showInDashboard: true,
      dashboardButtonText: "GEN SETTING",
      minAllowedAction: MenuActionsMappings[MenuNames.CONFIG].GET_GEN_SETTING,
    },
    "/relaxation-configuration/city-property/:id(\\d+)": {
      title: "Relaxation Configuration",
      path: "/relaxation-configuration/city-property/:id(\\d+)",
      text: "Relaxation Configuration On ID",
      menuName: MenuNames.CONFIG,
      showInDashboard: true,
      dashboardButtonText: "CITY PROPERTY",
      minAllowedAction: MenuActionsMappings[MenuNames.CONFIG].GET_GEN_SETTING,
    },
    "/gen-setting/change-logs": {
      title: "Change Logs",
      path: "/gen-setting/change-logs",
      text: "Change Logs",
      menuName: MenuNames.CONFIG,
      showInDashboard: true,
      dashboardButtonText: "GEN SETTING",
      minAllowedAction:
        MenuActionsMappings[MenuNames.CONFIG].GET_GEN_SETTING_CHANGE_LOGS,
    },
    "/city-property/change-logs/:id(\\d+)": {
      title: "Change Logs",
      path: "/city-property/change-logs/:id(\\d+)",
      text: "Change Logs On ID",
      menuName: MenuNames.CONFIG,
      showInDashboard: false,
      dashboardButtonText: "CITY PROPERTY",
      minAllowedAction:
        MenuActionsMappings[MenuNames.CONFIG].GET_CITY_PROPERTY_CHANGE_LOGS,
    },
    "/driver-tags-mappings-other": {
      title: "Other Tags Mappings",
      path: "/driver-tags-mappings-other",
      text: "Other Tags Mappings",
      menuName: MenuNames.DRIVER_TAG,
      showInDashboard: true,
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_TAG].MAPPING_LIST,
    },
    "/driver-tags-mappings-accounting": {
      title: "Accounting Tags Mappings",
      path: "/driver-tags-mappings-accounting",
      text: "Accounting Tags Mappings",
      menuName: MenuNames.DRIVER_TAG,
      showInDashboard: true,
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_TAG].MAPPING_LIST,
    },
    "/driver-accounting": {
      title: "Settlement Process",
      path: "/driver-accounting",
      text: "Settlement Process",
      menuName: MenuNames.DRIVER_ACCOUNTING,
      showInDashboard: true,
      dashboardButtonText: "Driver Accounting",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_ACCOUNTING]
          .SETTLEMENT_PROCESS_LIST,
    },
    "/driver-cash-transactions": {
      title: "Driver Cash Transactions",
      path: "/driver-cash-transactions",
      text: "Driver Cash Transactions",
      menuName: MenuNames.DRIVER_CASH_TRANSACTIONS,
      showInDashboard: true,
      dashboardButtonText: "Driver Cash Transactions",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_CASH_TRANSACTIONS].LIST,
    },
    "/driver-assets": {
      title: "Driver Assets",
      path: "/driver-assets",
      text: "Driver Assets",
      menuName: MenuNames.DRIVER_ASSETS,
      showInDashboard: true,
      dashboardButtonText: "Driver Assets",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_ASSETS].DRIVER_DETAIL,
    },
    "/assets": {
      title: "Assets",
      path: "/assets",
      text: "Assets",
      menuName: MenuNames.ASSET_MANAGEMENT,
      showInDashboard: true,
      dashboardButtonText: "Assets",
      minAllowedAction:
        MenuActionsMappings[MenuNames.ASSET_MANAGEMENT].DRIVER_DETAIL,
    },
    "/driver-medals": {
      title: "Driver Medals",
      path: "/driver-medals",
      text: "Driver Medals",
      menuName: MenuNames.DRIVER_MEDALS,
      showInDashboard: true,
      dashboardButtonText: "Driver Medals",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_MEDALS].DRIVER_DETAIL,
    },
    "/driver-assets-bulk": {
      title: "Bulk Upload Driver Assets",
      path: "/driver-assets-bulk",
      text: "Bulk Upload Driver Assets",
      menuName: MenuNames.DRIVER_ASSETS,
      showInDashboard: true,
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_ASSETS].BULK,
    },
    "/driver-assets-bulk-pickup": {
      title: "Bulk Upload Assets Pickup/Delivery",
      path: "/driver-assets-bulk-pickup",
      text: "Bulk Upload Assets Pickup/Delivery",
      menuName: MenuNames.DRIVER_ASSETS,
      showInDashboard: true,
      minAllowedAction: MenuActionsMappings[MenuNames.DRIVER_ASSETS].BULK,
    },
    "/driver-store-mapping-upload": {
      title: "Bulk Upload Driver Store Mappings ",
      path: "/driver-store-mapping-upload",
      text: "Bulk Upload Driver Store Mappings ",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/bulk-upload-driver-secondary-locality-mapping": {
      title: "Bulk Upload Driver Secondary Locality Mapping",
      path: "/bulk-upload-driver-secondary-locality-mapping",
      text: "Bulk Upload Driver Secondary Locality Mapping",
      menuName: MenuNames.BULK_UPLOAD_DRIVER_SECONDARY_LOCALITY_MAPPING,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[
          MenuNames.BULK_UPLOAD_DRIVER_SECONDARY_LOCALITY_MAPPING
        ].BULK_UPLOAD,
    },
    "/bulk-upload-driver-polygon-id": {
      title: "Bulk Upload Driver Polygon Id",
      path: "/bulk-upload-driver-polygon-id",
      text: "Bulk Upload Driver Polygon Id",
      menuName: MenuNames.BULK_UPSERT_POLYGON,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPSERT_POLYGON].BULK_UPSERT,
    },
    "/bulk-upload-incentive-multipliers": {
      title: "Bulk Upload Incentive Multipliers",
      path: "/bulk-upload-incentive-multipliers",
      text: "Bulk Upload Incentive Multipliers",
      menuName: MenuNames.INCENTIVE_MULTIPLIERS,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.INCENTIVE_MULTIPLIERS].BULK_UPLOAD,
    },
    "/bulk-create-polygon": {
      title: "Bulk Create Polygon",
      path: "/bulk-create-polygon",
      text: "Bulk Create Polygon",
      menuName: MenuNames.BULK_UPSERT_POLYGON,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPSERT_POLYGON].BULK_UPSERT,
    },
    "/bulk-update-polygon": {
      title: "Bulk Update Polygon",
      path: "/bulk-update-polygon",
      text: "Bulk Update Polygon",
      menuName: MenuNames.BULK_UPSERT_POLYGON,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPSERT_POLYGON].BULK_UPSERT,
    },
    "/blinkit-onboarding-upload": {
      title: "Bulk Upload Blinkit Onboarding drivers ",
      path: "/blinkit-onboarding-upload",
      text: "Bulk Upload Blinkit Onboarding drivers ",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/driver-zomato-to-blinkit-migration": {
      title: "Bulk Upload Zomato to Blinkit Migration",
      path: "/driver-zomato-to-blinkit-migration",
      text: "Bulk Upload Zomato to Blinkit Migration",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/driver-blinkit-to-zomato-migration": {
      title: "Bulk Upload Blinkit to Zomato Migration",
      path: "/driver-blinkit-to-zomato-migration",
      text: "Bulk Upload Blinkit to Zomato Migration",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/role-management": {
      title: "Role Management",
      path: "/role-management",
      text: "Role Management",
      menuName: MenuNames.ROLE_MANAGEMENT,
      showInDashboard: true,
      dashboardButtonText: "Role Management",
      minAllowedAction:
        MenuActionsMappings[MenuNames.ROLE_MANAGEMENT].ROLE_MANAGEMENT,
    },
    "/attribute-mapping": {
      title: "Attribute Mapping",
      path: "/attribute-mapping",
      text: "Attribute Mapping",
      menuName: MenuNames.ATTRIBUTE_MAPPING,
      showInDashboard: true,
      dashboardButtonText: "Attribute Mapping",
      minAllowedAction: MenuActionsMappings[MenuNames.ATTRIBUTE_MAPPING].LIST,
    },
    "/roles-bulk-upload": {
      title: "Roles Bulk Upload",
      path: "/roles-bulk-upload",
      text: "Roles Bulk Upload",
      menuName: MenuNames.BULK_UPLOAD_AUTH_DETAILS,
      showInDashboard: true,
      dashboardButtonText: "Roles Bulk Upload",
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPLOAD_AUTH_DETAILS]
          .BULK_UPLOAD_AUTH_DETAILS,
    },
    "/telecaller-profile": {
      title: "Telecaller Profiles",
      path: "/telecaller-profile",
      text: "Telecaller Profiles",
      menuName: MenuNames.TELECALLER_PROFILE,
      showInDashboard: true,
      dashboardButtonText: "Telecaller Profiles",
      minAllowedAction: MenuActionsMappings[MenuNames.TELECALLER_PROFILE].LIST,
    },
    "/trip-statistics": {
      title: "Trip Statistics",
      path: "/trip-statistics",
      text: "Trip Statistics",
      menuName: MenuNames.TRIP_STATISTICS,
      showInDashboard: true,
      dashboardButtonText: "Trip Statistics",
      minAllowedAction: MenuActionsMappings[MenuNames.TRIP_STATISTICS].LIST,
    },
    "/telecaller-leads": {
      title: "Telecaller Lead Assignments",
      path: "/telecaller-leads",
      text: "Telecaller Lead Assignments",
      menuName: MenuNames.TELECALLER_LEAD,
      showInDashboard: true,
      dashboardButtonText: "Telecaller Lead Assignments",
      minAllowedAction:
        MenuActionsMappings[MenuNames.TELECALLER_LEAD]
          .TELECALLER_LEAD_ASSIGNMENT,
    },
    "/assets-issuance": {
      title: "Assets Issuance",
      path: "/assets-issuance",
      text: "Assets Issuance",
      menuName: MenuNames.ASSETS_ISSUANCE,
      showInDashboard: true,
      dashboardButtonText: "Assets Issuance",
      minAllowedAction: MenuActionsMappings[MenuNames.ASSETS_ISSUANCE].CREATE,
    },
    "/trip-locality-property-bulk-upload": {
      title: "Trip Locality Property",
      path: "/trip-locality-property-bulk-upload",
      text: "Trip Locality Property",
      menuName: MenuNames.TRIP_LOCALITY_PROPERTY,
      showInDashboard: true,
      dashboardButtonText: "Bulk Upload Trip Locality Property",
      minAllowedAction:
        MenuActionsMappings[MenuNames.TRIP_LOCALITY_PROPERTY].BULK_UPLOAD,
    },
    "/leads-bulk-upload": {
      title: "Leads Bulk Upload",
      path: "/leads-bulk-upload",
      text: "Leads Bulk Upload",
      menuName: MenuNames.LEADS_BULK_UPLOAD,
      showInDashboard: true,
      dashboardButtonText: "Leads Bulk Upload",
      minAllowedAction:
        MenuActionsMappings[MenuNames.LEADS_BULK_UPLOAD].LEADS_BULK_UPLOAD,
    },
    "/delivery-drivers": {
      title: "Delivery Drivers",
      path: "/delivery-drivers",
      text: "Delivery Drivers",
      // oldDashboardLink: "/admin/deliverydrivers?disable_redirect_key=1",
      menuName: MenuNames.DRIVER,
      showInDashboard: true,
      dashboardButtonText: "Delivery Drivers",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER].DRIVER_DETAILS_VIEW,
    },
    "/delivery-drivers/:id/:detailType": {
      title: "Delivery Drivers",
      path: "/delivery-drivers/:id/:detailType",
      text: "Delivery Driver On ID",
      menuName: MenuNames.DRIVER,
      // oldDashboardLink: "/admin/deliverydrivers?disable_redirect_key=1",
      showInDashboard: false,
      dashboardButtonText: "Delivery Drivers",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER].DRIVER_DETAILS_VIEW,
    },
    "/tds-and-rider-payout-jobs": {
      title: "TDS & Rider Payout Jobs",
      path: "/tds-and-rider-payout-jobs",
      text: "TDS & Rider Payout Jobs",
      menuName: MenuNames.TDS_AND_RIDER_PAYOUT_JOBS,
      showInDashboard: true,
      dashboardButtonText: "TDS & Rider Payout Jobs",
      minAllowedAction:
        MenuActionsMappings[MenuNames.TDS_AND_RIDER_PAYOUT_JOBS].LIST,
    },
    "/bulk-update-tds-properties": {
      title: "Bulk Update TDS Properties",
      path: "/bulk-update-tds-properties",
      text: "Bulk Update TDS Properties",
      menuName: MenuNames.BULK_UPDATE_TDS_PROPERTIES,
      showInDashboard: true,
      dashboardButtonText: "Bulk Update TDS Properties",
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPDATE_TDS_PROPERTIES].BULK_UPLOAD,
    },
    "/bulk-update-restricted-payouts": {
      title: "Bulk Update Restricted Payouts",
      path: "/bulk-update-restricted-payouts",
      text: "Bulk Update Restricted Payouts",
      menuName: MenuNames.RESTRICTED_PAYOUTS,
      showInDashboard: true,
      dashboardButtonText: "Bulk Update Restricted Payouts",
      minAllowedAction:
        MenuActionsMappings[MenuNames.RESTRICTED_PAYOUTS].BULK_UPLOAD,
    },
    "/bulk-update-payout-hold": {
      title: "Bulk Update Payout Hold",
      path: "/bulk-update-payout-hold",
      text: "Bulk Update Payout Hold",
      menuName: MenuNames.BULK_UPDATE_PAYOUT_HOLD,
      showInDashboard: true,
      dashboardButtonText: "Bulk Update Payout Hold",
      minAllowedAction:
        MenuActionsMappings[MenuNames.BULK_UPDATE_PAYOUT_HOLD].BULK_UPLOAD,
    },
    "/bulk-request-driver-information": {
      title: "Bulk Request Driver Information",
      path: "/bulk-request-driver-information",
      text: "Bulk Request Driver Information",
      menuName: MenuNames.DRIVER_INFO_BULK_REQUEST,
      showInDashboard: true,
      dashboardButtonText: "Bulk Request Driver Information",
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_INFO_BULK_REQUEST].REQUEST_INFO,
    },
    "/issue-types": {
      title: "Issue Types",
      path: "/issue-types",
      text: "Issue Types",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: true,
      dashboardButtonText: "Issue Type",
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD].LIST,
    },
    "/issue-types/create": {
      title: "Create Issue Type",
      path: "/issue-types/create",
      text: "Create Issue Type",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD].CREATE,
    },
    "/issue-types/:id/:action": {
      title: "Issue Type Actions",
      path: "/issue-types/:id/:action",
      text: "Issue Type Actions",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD].DETAIL,
    },
    "/sub-issue-types": {
      title: "Sub Issue Types",
      path: "/sub-issue-types",
      text: "Sub Issue Types",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: true,
      dashboardButtonText: "Sub Issue Types",
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .LIST_SUB_ISSUE_TYPE,
    },
    "/sub-issue-types/create": {
      title: "Create Sub Issue Type",
      path: "/sub-issue-types/create",
      text: "Create Sub Issue Type",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .CREATE_SUB_ISSUE_TYPE,
    },
    "/sub-issue-types/:issueId": {
      title: "Sub Issue Types",
      path: "/sub-issue-types/:issueId",
      text: "Sub Issue Types",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .LIST_SUB_ISSUE_TYPE,
    },
    "/sub-issue-types/:id/:action": {
      title: "Sub Issue Types Actions",
      path: "/sub-issue-types/:id/:action",
      text: "Sub Issue Types Actions",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .LIST_SUB_ISSUE_TYPE,
    },
    "/sub-issue-types/sub-issue-tips": {
      title: "Sub Issue Tips",
      path: "/sub-issue-types/sub-issue-tips",
      text: "Sub Issue Tips",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .LIST_SUB_ISSUE_TYPE,
    },
    "/sub-issue-types/:id/tips": {
      title: "Sub Issue Tips",
      path: "/sub-issue-types/:id/tips",
      text: "Sub Issue Tips",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .LIST_SUB_ISSUE_TYPE,
    },
    "/sub-issue-types/:id/tips/create": {
      title: "Create Sub Issue Tip",
      path: "/sub-issue-types/:id/tips/create",
      text: "Create Sub Issue Tip",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .LIST_SUB_ISSUE_TYPE,
    },
    "/sub-issue-types/:id/tips/:tipId/:action": {
      title: "Sub Issue Tip Action",
      path: "/sub-issue-types/:id/tips/:tipId/:action",
      text: "Sub Issue Tip Action",
      menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
          .LIST_SUB_ISSUE_TYPE,
    },
    "/call-departments": {
      title: "Call Departments",
      path: "/call-departments",
      text: "Call Departments",
      menuName: MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS].READ,
    },
    "/call-departments/:id(\\d+)": {
      title: "Call Departments",
      path: "/call-departments/:id(\\d+)",
      text: "Call Departments",
      menuName: MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS,
      showInDashboard: false,
      minAllowedAction:
        MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS].READ,
    },
    "/user-properties": {
      title: "User Properties",
      path: "/user-properties",
      text: "User Properties",
      menuName: MenuNames.USER_PROPERTY,
      showInDashboard: true,
      minAllowedAction: MenuActionsMappings[MenuNames.USER_PROPERTY].READ,
    },
    "/v2/fleet-coach-driver-mapping": {
      title: "FC Driver Mapping",
      path: "/v2/fleet-coach-driver-mapping",
      text: "FC Driver Mapping",
      menuName: MenuNames.FLEET_COACH_V2,
      showInDashboard: true,
      minAllowedAction: MenuActionsMappings[MenuNames.FLEET_COACH_V2].LIST,
    },
    "/v2/fleet-coach-app-releases": {
      title: "Fleet Coach App Releases V2",
      path: "/v2/fleet-coach-app-releases",
      text: "Fleet Coach App Releases",
      menuName: MenuNames.FLEET_COACH_APP_RELEASE_V2,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.FLEET_COACH_APP_RELEASE_V2].LIST,
    },
    "/rain-reporting": {
      title: "Rain Reporting",
      path: "/rain-reporting",
      text: "Rain Reporting",
      menuName: MenuNames.GROUND_INTELLIGENCE,
      showInDashboard: true,
      dashboardButtonText: "Ground Intelligence",
      minAllowedAction:
        MenuActionsMappings[MenuNames.GROUND_INTELLIGENCE].RAIN_REPORTING,
    },
    "/prize-items": {
      title: "Prize Items",
      path: "/prize-items",
      text: "View Prize Items",
      menuName: MenuNames.PRIZE_ITEMS,
      showInDashboard: true,
      dashboardButtonText: "Prize Items",
      minAllowedAction: MenuActionsMappings[MenuNames.PRIZE_ITEMS].LIST,
    },
    "/campaigns": {
      title: "Campaigns",
      path: "/campaigns",
      text: "View Campaigns",
      menuName: MenuNames.CAMPAIGNS,
      showInDashboard: true,
      dashboardButtonText: "Campaigns",
      minAllowedAction: MenuActionsMappings[MenuNames.CAMPAIGNS].LIST,
    },
    "/feature-config/details": {
      title: "Details",
      path: "/feature-config/details",
      text: "View Details",
      menuName: MenuNames.FEATURE_CONFIG,
      showInDashboard: false,
      dashboardButtonText: "Details",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_CONFIG].VIEW,
    },
    "/feature-config/list": {
      title: "Details",
      path: "/feature-config/list",
      text: "View List",
      menuName: MenuNames.FEATURE_CONFIG,
      showInDashboard: false,
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_CONFIG].VIEW,
    },
    "/feature-config/namespaces": {
      title: "Namespaces",
      path: "/feature-config/namespaces",
      text: "Namespaces",
      menuName: MenuNames.FEATURE_CONFIG,
      showInDashboard: true,
      dashboardButtonText: "Namespaces",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_CONFIG].VIEW,
    },
    "/feature-config/access-control": {
      title: "Config Access Control",
      path: "/feature-config/access-control",
      text: "Access Control",
      menuName: MenuNames.FEATURE_CONFIG,
      showInDashboard: true,
      dashboardButtonText: "Feature Config Access Control",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_CONFIG].VIEW,
    },
    "/feature-config": {
      title: "Feature Config",
      path: "/feature-config",
      text: "Feature Config",
      menuName: MenuNames.FEATURE_CONFIG,
      showInDashboard: true,
      dashboardButtonText: "Feature Config",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_CONFIG].VIEW,
    },
    "/feature-config/bulk-upload": {
      title: "Bulk Upload Feature Config",
      path: "/feature-config/bulk-upload",
      text: "Bulk Upload Feature Config",
      menuName: MenuNames.FEATURE_CONFIG,
      showInDashboard: true,
      dashboardButtonText: "Bulk Upload Feature Config",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_CONFIG].VIEW,
    },
    "/feature-config/bulk-delete": {
      title: "Bulk Delete Feature Config",
      path: "/feature-config/bulk-delete",
      text: "Bulk Delete Feature Config",
      menuName: MenuNames.FEATURE_CONFIG,
      showInDashboard: true,
      dashboardButtonText: "Bulk Delete Feature Config",
      minAllowedAction: MenuActionsMappings[MenuNames.FEATURE_CONFIG].VIEW,
    },
    "/bulk-upload-driver-properties": {
      title: "Bulk Upload Driver Properties",
      path: "/bulk-upload-driver-properties",
      text: "Bulk Upload Driver Properties",
      menuName: MenuNames.SLOT_CAPACITY_UPDATE,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.SLOT_CAPACITY_UPDATE].BULK_UPLOAD,
    },
    "/bulk-upload-driver-reservation": {
      title: "Bulk Upload Driver Reservation",
      path: "/bulk-upload-driver-reservation",
      text: "Bulk Upload Driver Reservation",
      menuName: MenuNames.DRIVER_RESERVATION,
      showInDashboard: true,
      minAllowedAction:
        MenuActionsMappings[MenuNames.DRIVER_RESERVATION]
          .DRIVER_RESERVATIONS_BULK_CREATE,
    },
    "/qr-generator": {
      title: "QR Generator",
      path: "/qr-generator",
      text: "QR Generator",
      menuName: MenuNames.QR_GENERATOR,
      showInDashboard: true,
      dashboardButtonText: "QR Generator",
      minAllowedAction: MenuActionsMappings[MenuNames.QR_GENERATOR].VIEW,
    },
  },
  navItems: {
    Gigs: {
      urls: [
        "/slot-capacity-update",
        "/slot-capacity-attendance-exemption",
        "/driver-slots-attendance-exemption",
        "/driver-star-gigs-exemption",
        "/bulk-gigs-opt-out",
        "/bulk-gigs-opt-in",
        "/gigs-cancellation-fee-exemption",
        "/driver-gigs-cancellation-fee-exemption",
        "/slots-details",
        "/slots-details/:id(\\d+)",
        "/gigs-support",
        "/gigs-capacity-change",
      ],
      icon: "/images/navIcons/operations.svg",
    },
    Onboarding: {
      urls: [
        /* PLOP_TEMPLATE_NAV_ITEMS_INJECT */
        "/bulk-upload-ev-inventory",
        "/qc-details",
        "/qc-details-v2",
        "/qc-details-v2/:feId",
        "/dlrc-details",
        "/onboarding-details",
      ],
      icon: "/images/navIcons/onboarding.svg",
    },
    Operations: {
      urls: [
        "/feature",
        "/feature-toggle",
        "/leads-bulk-upload",
        "/feature-toggle-delete-by-ids",
        "/selfies",
        "/driver-app-releases",
        "/driver-shelter",
        "/bulk-modify-shelter",
        "/v2/fleet-coach-app-releases",
        "/bulk-upload-bonuses",
        "/bulk-upload-ob-tags",
        "/disputes",
        "/disputes/:id/:detailType?",
      ],
      icon: "/images/navIcons/operations.svg",
    },
    "Rider Profile": {
      urls: [
        "/delivery-drivers",
        "/delivery-drivers/:id/:detailType",
        "/driver-tags",
        "/driver-tags-mappings-other",
        "/driver-tags-mappings-accounting",
        "/bulk-upload-driver-properties",
        "/driver-assets",
        "/driver-medals",
        "/bulk-request-driver-information",
        "/driver-properties-upload",
        "/driver-assets-bulk",
        "/driver-assets-bulk-pickup",
        "/assets-issuance",
        "/trip-statistics",
        "/driver-asset-issuance-tracking",
        "/driver-store-mapping-upload",
        "/bulk-upload-driver-secondary-locality-mapping",
        "/blinkit-onboarding-upload",
        "/bulk-upload-carrier-change-manager",
        "/driver-zomato-to-blinkit-migration",
        "/driver-blinkit-to-zomato-migration",
        "/assets",
        "/bulk-upload-driver-reservation",
        "/bulk-upload-driver-polygon-id",
        "/bulk-create-polygon",
        "/bulk-update-polygon",
        "/bulk-upload-incentive-multipliers",
      ],
      icon: "/images/navIcons/user.svg",
    },
    "Driver Communication": {
      urls: [
        "/notification_campaigns",
        "/notification_campaigns/:id",
        "/notification_campaign/create_campaign",
        "/stories",
        "/stories/create_campaign",
        "/stories/create_external_entity",
        "/stories/:id",
        "/communication-hub",
        "/communication-hub/new/:tag",
        "/communication-hub/:tag/:id",
        "/communication-hub/history/:tag/:id",
        "/banner",
      ],
      icon: "/images/navIcons/videotv.svg",
    },
    "Driver Support": {
      urls: [
        "/rider-payouts",
        "/rider-offers",
        "/platform-fee-details",
        "/order-payout",
        "/order-payout/:filter_type/:filter_value",
      ],
      icon: "/images/navIcons/user.svg",
    },
    Xtreme: {
      urls: ["/lifeline", "/lifeline/:filter_type/:filter_value"],
      icon: "/images/xtreme.svg",
    },
    "Logistics Support": {
      urls: [
        "/chat-departments",
        "/chat-departments/:id(\\d+)",
        "/issue-types",
        "/issue-types/action",
        "/sub-issue-types",
        "/sub-issue-types/action",
        "/call-departments",
        "/call-departments/:id(\\d+)",
      ],
      icon: "/images/navIcons/user.svg",
    },
    "Fleet Coach V2": {
      urls: [
        "/v2/fleet-coach-bulk-upload",
        "/v2/fleet-coach",
        "/v2/fleet-coach/:id",
        "/v2/fleet-coach-driver-mapping",
        "/v2/fleet-coach-task",
      ],
      icon: "/images/navIcons/user.svg",
    },
    "Merchant Support": {
      urls: ["/merchant-facade"],
      icon: "/images/navIcons/user.svg",
    },
    Walker: {
      urls: ["/Walker", "/Poi", "/walker-details"],
      icon: "/images/navIcons/user.svg",
    },
    "Spin The Wheel": {
      urls: [
        "/bulk-inventory-upload",
        "/inventories",
        "/bulk-coupon-upload",
        "/prize-items",
        "/campaigns",
      ],
      icon: "/images/navIcons/user.svg",
    },
    "Cache Dashboard": {
      urls: ["/ofs-cache-dashboard"],
      icon: "/images/navIcons/user.svg",
    },
    "Ground Intelligence": {
      urls: ["/rain-reporting"],
      icon: "/images/navIcons/user.svg",
    },
    "Roles & Permissions": {
      urls: ["/role-management", "/roles-bulk-upload", "/attribute-mapping"],
      icon: "/images/navIcons/accounting.svg",
    },
    Telecallers: {
      urls: ["/telecaller-profile", "/telecaller-leads"],
      icon: "/images/navIcons/user.svg",
    },
    "Driver Accounting": {
      urls: [
        "/driver-accounting",
        "/driver-cash-transactions",
        "/tds-and-rider-payout-jobs",
        "/bulk-update-tds-properties",
        "/bulk-update-restricted-payouts",
        "/pending-deduction",
        "/driver-tds-certificates",
        "/restricted-payout-drivers",
      ],
      icon: "/images/navIcons/accounting.svg",
    },
    "Trip Locality Property": {
      urls: ["/trip-locality-property-bulk-upload"],
      icon: "/images/navIcons/accounting.svg",
    },
    "Geo Dashboards": {
      urls: [
        "/states",
        "/states/:id(\\d+)",
        "/countries",
        "/cities",
        "/countries/:id(\\d+)",
        "/cities/:id(\\d+)",
        "/localities",
        "/localities/:id(\\d+)",
        "/polygons",
        "/polygons/:id",
        "/polygons-types",
        "/boundaries",
      ],
      icon: "/images/navIcons/india.svg",
    },
    Orders: {
      urls: ["/orders", "/orders/:id/:detailType?"],
      icon: "/images/zomato-logo.svg",
    },
    "Config Dashboard": {
      urls: [
        "/relaxation-configuration/gen-setting",
        "/gen-setting/change-logs",
        "/city-property/change-logs",
      ],
      icon: "/images/navIcons/accounting.svg",
    },
    Properties: {
      urls: ["/user-properties"],
      icon: "/images/navIcons/user.svg",
    },
    FeatureConfig: {
      urls: [
        "/feature-config/bulk-upload",
        "/feature-config",
        "/feature-config/namespaces",
        "/feature-config/bulk-delete",
        "/feature-config/access-control",
      ],
      icon: "/images/navIcons/accounting.svg",
    },
    QRDashboard: {
      urls: ["/qr-generator"],
      icon: "/images/navIcons/accounting.svg",
    },
  },
};

export default data;
